export default __webpack_public_path__ + "static/media/digital-empire-big-6@2x.d3f930cb.png";